
import jCompanyLocation from '@/views/location/jCompanyLocation';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/administrator/location',
    name: 'jCompanyLocation',
    component: jCompanyLocation,
    meta: {
      title: 'Company Location',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterLocation.js